import { useState } from "react";
import { Card } from "react-bootstrap";
import { ChevronExpand } from "react-bootstrap-icons";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectIsMetric } from "../../../../store/slices/settingsSlice";

function FactoredTensionResistance() {
  const { t } = useTranslation("translation");
  const [showResults, setShowResults] = useState(true);

  const isMetric = useSelector(selectIsMetric);

  const onClick = () => setShowResults(!showResults);

  return (
    <>
      <div className="col-8" style={{ paddingTop: "10px" }}>
        <Card bg={"light"} key={1} text={"dark"} style={{ width: "100%" }} className="mb-2">
          <Card.Header onClick={onClick}>
            {t("aashto.inner.Tension")}
            <button type="button" className="float-end" style={{ border: "none" }}>
              {showResults ? t("hideDetails") : t("showDetails")}
              <ChevronExpand style={{ marginLeft: "10px" }} />
            </button>
          </Card.Header>
          {showResults && (
            <Card.Body>
              <p>
                R<sub>TU</sub> = &Phi;<sub>TU</sub>R<sub>n</sub> {t("aashto.inner.for which")} R
                <sub>n</sub> = F<sub>y</sub>A<sub>b</sub>
              </p>
              <br />
              <dl style={{ color: "#3f3f40", fontSize: "12px" }}>
                <dt>
                  &Phi;<sub>TU</sub>
                </dt>
                <dd>
                  {t("aashto.inner.PhiTU_Description")}
                  {/* Resistance factor spcified in Table 10.5.5.2.5-2 for
                    structural resitance of the uncased section of micropile in
                    subjected to tension loading */}
                </dd>
                <dt>
                  F<sub>y</sub>
                </dt>
                <dd>
                  <Trans
                    i18nKey="aashto.inner.Fy_Description"
                    values={{
                      unit: isMetric ? "MPa" : "ksi",
                    }}
                  />
                </dd>
                <dt>
                  A<sub>b</sub>
                </dt>
                <dd>
                  <Trans
                    i18nKey="aashto.inner.Ab_Description"
                    values={{
                      unit: isMetric ? "mm²" : "in²",
                    }}
                  />
                </dd>
              </dl>
            </Card.Body>
          )}
        </Card>
      </div>
    </>
  );
}

export default FactoredTensionResistance;
